interface PumsemMessageProps {
  title: string;
  body: string;
}

/** 빈 상태·오류를 같은 자리·같은 모양으로. */
export function PumsemMessage({ title, body }: PumsemMessageProps) {
  return (
    <div className="px-6 py-24 text-center">
      <p className="text-[17px] font-bold text-neutral-800 dark:text-neutral-100">
        {title}
      </p>
      <p className="mt-2 text-[15px] text-neutral-500 dark:text-neutral-400">
        {body}
      </p>
    </div>
  );
}

